import { Controller } from "@hotwired/stimulus";
import Cropper from 'cropperjs';

export default class extends Controller {
  static outlets = [ "inputs--image" ];
  static targets = ["image", "modal"];
  static values = { imageOutletId: String, sizeClass: String };

  connect() {
    if (!this.hasImageTarget) return;

    const sizes = this.getSize();
    const ratio = sizes.width / sizes.height;
    
    this.cropper = new Cropper(this.imageTarget, {
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      background: false,
      aspectRatio: ratio,

      ready: () => {
        document.getElementById('cropper-modal-body-content').classList.remove('invisible');
      }
    });
  };

  saveCroppedImage() {
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      const file = new File([blob], 'cropped.png', { type: 'image/png' });

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);

      const input = this.inputsImageOutlet.inputTarget;
      input.files = dataTransfer.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 'image/png');

    this.closeModal();
  };

  openModal() {
    document.body.insertAdjacentHTML('beforeend', this.modal());
  };

  closeModal() {
    this.modalTarget.remove();
  };

  getSize() {
    const [w, h] = this.sizeClassValue.match(/\d+/g)?.map(Number) || [];

    return { width: w, height: h };
  };

  resetImage() {
    this.cropper.reset();
  };

  modal() {
    return `
      <div id='cropper-modal-background'
           data-controller='inputs--cropper'
           data-inputs--cropper-inputs--image-outlet="#${this.imageOutletIdValue}"
           data-inputs--cropper-size-class-value="${this.sizeClassValue}"
           data-inputs--cropper-target='modal'
           tabindex='-1'
           class='bg-gray-900/60 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 md:inset-0 h-full justify-center items-center flex'
      >
        <div id="cropper-modal-wrapper" class='relative p-4 w-full max-w-3xl md:h-auto z-50 max-h-full overflow-y-auto overflow-x-hidden'>
          <div id="cropper-modal-inner" @keyup.escape.window="document.getElementById('cropper-modal-close').click();" class='relative p-4 w-full max-w-3xl h-full bg-white md:h-auto mx-auto rounded-lg'>
            <div class="flex justify-end p-2">
              <h2 class="text-xl text-slate-800 font-bold w-full text-left mb-4">
                cropper image
                <button id="cropper-modal-close"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg float-right text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                        data-action="inputs--cropper#closeModal"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </button>
              </h2>
            </div>
            <div id="cropper-modal-body-content" class="p-2 invisible">
              <div id="cropper-modal-container">
                <img data-inputs--cropper-target="image"
                    id="cropper-modal-img"
                    crossorigin="anonymous"
                    src="${this.inputsImageOutlet.previewTarget.src}"
                />
              </div>
            </div>
             <div id="cropper-modal-controls" class="flex justify-between space-x-3 mt-3 border-t border-slate-200 pt-3 items-center">
                <button data-action="inputs--cropper#resetImage" class="text-primary-500">
                  Reset
                </button>

              <div class="w-1/2 flex space-x-3">
                <button class="btn-secondary w-full" data-action="inputs--cropper#closeModal">
                  Cancel
                </button>
                <button class='btn-primary w-full' data-action='inputs--cropper#saveCroppedImage'>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  };
};